import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  cancelInterest: {
    margin: 0,
    width: '100%',
    flexGrow: 1,
    maxWidth: 1440,
    display: 'flex',
    padding: '32px 40px',
    alignItems: 'center',
  },
  container: {
    display: 'grid',
    gridTemplateRows: '1fr auto',
    background: '#FFFFFF',
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(19, 45, 74, 0.04)',
    borderRadius: 8,
    height: '100%',
    maxWidth: 1520,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxHeight: 984,
    },
  },
  containerText: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down(760)]: {
      flexDirection: 'column',
      textAlign: 'center',
    },
  },
  containerBottom: {
    padding: '24px 32px',
    borderTop: `1px solid ${theme.palette.secondary.light}`,
    alignItems: 'center',
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  trash: {
    maxWidth: '100%',
    margin: '0 152px 0 112px',
    [theme.breakpoints.down(760)]: {
      margin: '32px auto 32px',
      width: '112px',
      height: 'auto',
    },
  },
  padlock: {
    objectFit: 'contain',
    marginRight: 24,
  },
  containerTop: {
    padding: '32px',
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
  },
  link: {
    margin: 'auto 1ch',
    color: theme.palette.primary.main,
    textDecoration: 'none',
  },
  text: {
    lineHeight: '16px',
    marginRight: 24,
    [theme.breakpoints.down('xs')]: {
      marginRight: 0,
    },
  },
  cancel: {
    marginLeft: 24,
    padding: '8px 16px',
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
      marginBottom: 16,
    },
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
  flexGrow: {
    flexGrow: 0,
  },
  containerButton: {
    display: 'flex',
    gap: 16,
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column-reverse',
      width: '100%',
    },
  },
  containerArticle: {
    display: 'flex',
    marginTop: 16,
    padding: '24px 24px',
    background: '#FFFFFF',
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(19, 45, 74, 0.04)',
    borderRadius: 8,
  },
}))
